import deAnalytics from './locales/de/analytics.json';
import deAppointments from './locales/de/appointments.json';
import deAuth from './locales/de/auth.json';
import deBot from './locales/de/bot.json';
import deCommon from './locales/de/common.json';
import deDashboard from './locales/de/dashboard.json';
import dePractice from './locales/de/practice.json';
import deRevenue from './locales/de/revenue.json';
import deTickets from './locales/de/tickets.json';
import deUsers from './locales/de/users.json';
import deUtilization from './locales/de/utilization.json';
import deWhatsapp from './locales/de/whatsapp.json';
import enAnalytics from './locales/en/analytics.json';
import enAppointments from './locales/en/appointments.json';
import enAuth from './locales/en/auth.json';
import enBot from './locales/en/bot.json';
import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enPractice from './locales/en/practice.json';
import enRevenue from './locales/en/revenue.json';
import enTickets from './locales/en/tickets.json';
import enUsers from './locales/en/users.json';
import enUtilization from './locales/en/utilization.json';
import enWhatsapp from './locales/en/whatsapp.json';

// One namespace per domain. German is the source language (production default).
export const resources = {
  de: {
    common: deCommon,
    auth: deAuth,
    dashboard: deDashboard,
    appointments: deAppointments,
    practice: dePractice,
    revenue: deRevenue,
    utilization: deUtilization,
    users: deUsers,
    tickets: deTickets,
    whatsapp: deWhatsapp,
    bot: deBot,
    analytics: deAnalytics,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    appointments: enAppointments,
    practice: enPractice,
    revenue: enRevenue,
    utilization: enUtilization,
    users: enUsers,
    tickets: enTickets,
    whatsapp: enWhatsapp,
    bot: enBot,
    analytics: enAnalytics,
  },
} as const;

export const defaultNS = 'common';

export type Language = keyof typeof resources;
export const languages = Object.keys(resources) as Language[];
